import {Component, OnInit, Input, ViewChild, AfterViewInit} from '@angular/core';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'app-payroll-additional-costs',
  templateUrl: './payroll-additional-costs.component.html',
  styleUrls: ['./payroll-additional-costs.component.css']
})
export class PayrollAdditionalCostsComponent implements OnInit {
  @Input() payrollInvoice;
  @Input() index;
  @Input() isClient = false;
  @ViewChild('payrollAdditionalCostFields') public form: NgForm;
  @Input() parentForm: NgForm;
  @Input() isReadOnly = false;
  interpTransfersPlaceHolder = '$0';
  mealsPlaceHolder = '$0';
  accomPlaceHolder = '$0';
  flightsPlaceHolder = '$0';

  constructor() { }

  ngOnInit() {
    if (Boolean(this.parentForm ) && Boolean(this.parentForm.form)) {
        let ctrlName = 'additionalCostsFields_' + (this.isClient ? 'client_' : 'interpreter_') + this.index;

        if (!this.parentForm.form.contains(ctrlName)) {
            this.parentForm.form.addControl(ctrlName, this.form.form);
        }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/booking-management/payroll-additional-costs/payroll-additional-costs.component.ts